import { ModelDef } from '../index'
const md5 = require('md5')

const model: ModelDef = {
  bulkEditable: true,
  columns: {
    group: {
      label: 'グループ',
      type: 'STRING',
      unique: false,
      validate: {
        notEmpty: true,
      },
      selectionsWithAlgoFacetsColName: 'group',
      strictSelections: false,
      dynamicSelections: true,
      facet: { showOnSearch: true },
    },
    value: {
      label: '値',
      type: 'STRING',
      unique: {
        conditions: (record) => ({ group: record.group }),
      },
      validate: {
        notEmpty: true,
      },
      facet: true,
    },
    category: {
      label: '中分類',
      type: 'STRING',
      facet: { showOnSearch: true },
    },
    order: {
      default: 0,
      label: '表示順(昇順)',
      type: 'TEXT',
      unique: false,
      validate: {
        isInt: true,
      },
    },
  },
  showOnMainmenu: false,
  showOnSettingMenu: true,
  tableComment: 'XXX',
  tableLabel: '選択肢マスタ',
  tableName: 'selectOptionsMaster',
  defaultSort: { key: 'group', order: 'asc' },
  algoSettings: {
    sorting: ['asc(group)', 'asc(order)'],
  },
  shouldCreateHistoryData: ({ before, after }) => true,
  beforeSave(row: any, oldData: any) {
    if (!row.id) {
      row.idUnHashed = `${row.group}--${row.value}`
      row.id = md5(row.idUnHashed)
    }
    return row
  }
}

export default model
